<div class="mbfs-primary">
  <header id="mbfs-header">
  <div class="mbfs-header">
  <div class="mbfs-header-inner">
<div *ngIf="!displayDefault && !displayFleet  && !guestPay" class="mbfs-header-inner">
    <div [class.fullnav]="!this.registration">

      <!--US Logo-->
        <a *ngIf="!isCanadaPortal" id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
            <div class="mbfs-logotype">
                <img id="mbfs-header-mbfs-logotype-img" href="/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/newlogo.jpg" alt="titlecopy">
            </div>
        </a>

      <!--Canada En Logo-->
        <a *ngIf="isCanadaPortal && this.language === 'en-CA'" id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
            <div class="mbfs-logotype">
                <img id="mbfs-header-mbfs-logotype-img" href="/ca/en/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/newlogo.jpg" alt="titlecopy">
            </div>
        </a>

      <!--Canada Fr Logo-->
        <a *ngIf="isCanadaPortal && this.language === 'fr-CA'" id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
            <div class="mbfs-logotype">
                <img id="mbfs-header-mbfs-logotype-img" href="/ca/fr/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/newlogo.jpg" alt="titlecopy">
            </div>
        </a>



        <div [ngClass]="displayCloseIcon? 'mbfs-navigation-wrapper mbfs-navigation-wrapper_new_nav':'mbfs-navigation-wrapper'">
        <div [ngClass]="displayCloseIcon? 'mbfs-authentication-tools mbfs-authentication-tools_display':'mbfs-authentication-tools'">

          <!--If User is Not Authenticated Shows the following -->
          <ul *ngIf="this.isAuthenticated">
            <li *ngIf="!isCanadaPortal && GuestPay">
              <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickGuestPay()">{{'NavHeader.Repay' | translate }}</a>
            </li>
              <li>
                  <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="{{this.targetRedirect}}">{{'NavHeader.MyAccount' | translate }}</a>
              </li>
              <li>
                  <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogout($event)">{{'NavHeader.Logout' | translate }}</a>
              </li>
              <li *ngIf="isCanadaPortal">
                <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="this.translateUtil.onLanguageChangeClick();">{{'NavHeader.language' | translate }}</a>
              <li>
              <li>
                <span id="mbfs-header-menu-cta"class="mbfs-header-login-cta-a" href="javascript:void(0)">{{'NavHeader.Menu' | translate }}</span>
              </li>
          </ul>

          <!--If User is Authenticated Shows the following -->
          <ul *ngIf="!this.isAuthenticated">
            <li *ngIf="!isCanadaPortal  && GuestPay">
              <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickGuestPay()">{{'NavHeader.Repay' | translate }}</a>
            </li>
              <li>
                <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onRegistrationClick($event)">{{'NavHeader.Register' | translate }}</a>
            </li>
              <li>
                <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)">{{'NavHeader.Login' | translate }}</a>
             </li>
             <li *ngIf="isCanadaPortal">
              <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="this.translateUtil.onLanguageChangeClick();">{{'NavHeader.language' | translate }}</a>
              <li>
                <span id="mbfs-header-menu-cta" role="button" class="mbfs-header-login-cta-a"href="javascript:void(0)">{{'NavHeader.Menu' | translate }}</span>
              </li>
          </ul>
        </div>

        <!--Code that triggers the hamburger menu dropdown-->
        <a  role="button" aria-label="Open" id="mbfs-header-menu-cta" href="#" class="mbfs-navigation" (click)="onHamburgerClick($event)">
          <div class="mbfs-navigation-hamburger">
              <div [ngClass]="displayCloseIcon? 'mbfs-header-menu-close' : 'mbfs-hamburger-link'">
                  <span class="mbfs-hamburger-line mbfs-hamburger-top"></span>
                  <span class="mbfs-hamburger-line mbfs-hamburger-middle"></span>
                  <span class="mbfs-hamburger-line mbfs-hamburger-bottom"></span>
              </div>
          </div>
      </a>
        </div>
        <div class="mbfs-mainnav"></div>
    </div>
</div>

<div *ngIf="displayDefault && displayAdmin && !displayFleet" class="mbfs-header-inner">
  <div [class.fullnav]="!this.registration">

    <!--US Logo-->
      <a  id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
          <div class="mbfs-logotype">
              <img id="mbfs-header-mbfs-logotype-img" href="/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/newlogo.jpg" alt="titlecopy">
          </div>
      </a>

      <div [ngClass]="displayCloseIcon? 'mbfs-navigation-wrapper mbfs-navigation-wrapper_new_nav':'mbfs-navigation-wrapper'">
      <div [ngClass]="displayCloseIcon? 'mbfs-authentication-tools mbfs-authentication-tools_display':'mbfs-authentication-tools'">

        <!--If User is Not Authenticated Shows the following -->
        <ul *ngIf="this.isAdminAuthenticated">
          <!-- <li>
            <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" >{{'NavHeader.Repay' | translate }}</a>
         </li> -->
            <li>
                <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="{{this.adminRedirect}}">{{'NavHeader.MyAccount' | translate }}</a>
            </li>
            <li>
                <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogout($event)">{{'NavHeader.Logout' | translate }}</a>
            </li>
        </ul>

        <!--If User is Authenticated Shows the following -->
        <ul *ngIf="!this.isAdminAuthenticated">
            <li>
              <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)">{{'NavHeader.Login' | translate }}</a>
           </li>
        </ul>
      </div>

      <!--Code that triggers the hamburger menu dropdown-->
    <a role="button" aria-label="Open" id="mbfs-header-menu-cta" href="#" class="mbfs-navigation" (click)="onHamburgerClick($event)">
      <div class="mbfs-navigation-hamburger">
        <div [ngClass]="displayCloseIcon? 'mbfs-header-menu-close' : 'mbfs-hamburger-link'">
          <span class="mbfs-hamburger-line mbfs-hamburger-top"></span>
          <span class="mbfs-hamburger-line mbfs-hamburger-middle"></span>
          <span class="mbfs-hamburger-line mbfs-hamburger-bottom"></span>
        </div>
      </div>
    </a>
      </div>
      <div class="mbfs-mainnav"></div>
  </div>
</div>

<!--DefaultHeader-->
<div *ngIf="displayDefault && !displayAdmin && !displayFleet">
  <div class="mbfs-header-inner">
    <div [class.fullnav]="!this.registration">

      <!--US Logo-->
        <a id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
            <div class="mbfs-logotype">
                <img id="mbfs-header-mbfs-logotype-img" href="/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/newlogo.jpg" alt="titlecopy">
            </div>
        </a>
    </div>
</div>
</div>

<div *ngIf="displayFleet" class="mbfs-header-inner">
  <div [class.fullnav]="!this.registration">

    <!--US Logo-->
      <a id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
          <div class="mbfs-logotype">
              <img id="mbfs-header-mbfs-logotype-img" href="/home" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/Daimler_Truck_FS_Logotype_1L_White_RGB.svg" alt="titlecopy">
          </div>
      </a>

      <div [ngClass]="displayCloseIcon? 'mbfs-navigation-wrapper mbfs-navigation-wrapper_new_nav':'mbfs-navigation-wrapper'">
      <div [ngClass]="displayCloseIcon? 'mbfs-authentication-tools mbfs-authentication-tools_display':'mbfs-authentication-tools'">

        <!--If User is Not Authenticated Shows the following -->
        <ul *ngIf="this.isAuthenticated">
          <li *ngIf="!isCanadaPortal  && GuestPay">
            <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickGuestPay()">{{'NavHeader.Repay' | translate }}</a>
          </li>
            <li>
                <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="{{this.targetRedirect}}">{{'NavHeader.MyAccount' | translate }}</a>
            </li>
            <li>
                <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogout($event)">{{'NavHeader.Logout' | translate }}</a>
            </li>
            <li *ngIf="isCanadaPortal">
              <a id="mbfs-header-login-cta" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="this.translateUtil.onLanguageChangeClick();">{{'NavHeader.language' | translate }}</a>
            <li>
            <!-- <li>
              <span id="mbfs-header-menu-cta"class="mbfs-header-login-cta-a" href="javascript:void(0)">{{'NavHeader.Menu' | translate }}</span>
            </li> -->
        </ul>

        <!--If User is Authenticated Shows the following -->
        <ul *ngIf="!this.isAuthenticated">
          <li *ngIf="!isCanadaPortal  && GuestPay">
            <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickGuestPay()">{{'NavHeader.Repay' | translate }}</a>
          </li>
            <li>
              <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onRegistrationClick($event)">{{'NavHeader.Register' | translate }}</a>
          </li>
            <li>
              <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)">{{'NavHeader.Login' | translate }}</a>
           </li>
           <li *ngIf="isCanadaPortal">
            <a id="mbfs-header-login-cta" role="button" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="this.translateUtil.onLanguageChangeClick();">{{'NavHeader.language' | translate }}</a>
            <!-- <li>
              <span id="mbfs-header-menu-cta" role="button" class="mbfs-header-login-cta-a"href="javascript:void(0)">{{'NavHeader.Menu' | translate }}</span>
            </li> -->
        </ul>
      </div>
      </div>
      <div class="mbfs-mainnav"></div>
  </div>
</div>

<div *ngIf="!displayAdmin">
  <!-- Login Modal check user-->
  <!-- <form [formGroup]="userForm" (ngSubmit)="submitUserForm($event)" *ngIf="openLoginModal && !userExist">
    <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
      <div class="mbfs-modal-overlay"></div>

      <div class="mbfs-modal-content" *ngIf="!isReset && !userExist">
          <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
          <div class="mbfs-bank-profile-create-inner">
              <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                <div class="form-group row m-2">
                  <div class="input-group">
                    <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
                    <input type="text" id="userID" name="userID" class="col-md-6 form-control"
                      formControlName="userID" required validateonblur
                      value="" autocomplete="off" [class.mbfs-value]="loginForm.get('userID').value" />
                </div>
              </div>
              <p class="mbfs-field-assistance">
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.required">{{ 'Errors.userIdRequired' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.minlength">{{ 'Errors.userIdminlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.maxlength">{{ 'Errors.userIdmaxlength' | translate }}<br></span>
              </p>
              </div>

            <div class="captcha" *ngIf="this.captchaToggle">
              <div id="capcha_element" class="g-recaptcha" data-theme="light"
                  style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
                  data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
                </div>
            </div>
            <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
            <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              <br>
          </div>
          <div class ="registrationlinks">
<ul class="nav">
  <li><a [routerLink]="[]" (click)="toggleForgotUserFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ForgotUser' | translate }}</a></li>
</ul>
          </div>
      </div>

  </div>
  </form> -->

  <!-- Login Modal Code if User Exists -->
  <form [formGroup]="loginForm" (ngSubmit)="login()" *ngIf="openLoginModal && !userExist">
    <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
      <div class="mbfs-modal-overlay"></div>

      <!--If user Exists and and password does not need to be reset -->
      <div class="mbfs-modal-content" *ngIf="isReset">
          <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
          <div class="mbfs-bank-profile-create-inner">
              <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                <div class="form-group row m-2">
                  <div class="input-group">
                    <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
                    <input type="text" id="userID" name="userID" class="col-md-6 form-control"
                      formControlName="userID" required validateonblur
                      value="userForm.get('userID').value" autocomplete="off" [class.mbfs-value]="userForm.get('userID').value" />
                </div>
              </div>
              <p class="mbfs-field-assistance">
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.required">{{ 'Errors.userIdRequired' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.minlength">{{ 'Errors.userIdminlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.maxlength">{{ 'Errors.userIdmaxlength' | translate }}<br></span>

              </p>
              </div>

              <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                <div class="form-group row m-2">
                  <div class="input-group">
                    <label for="password" class="col-md-3 col-form-label">{{ 'LoginModal.PasswordLabel' | translate }}</label>
                    <input type="password" name="password" id="password" #password1 class="col-md-6 form-control"
                    formControlName="password" required validateonblur
                    value="" onPaste="return false" autocomplete="off" [class.mbfs-value]="loginForm.get('password').value">
                    <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, 1)">
                      <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                    </div>
                  </div>
                </div>
                <p class="mbfs-field-assistance">
                  <span class="spanRedTag"
                  *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.required">{{ 'Errors.passwordRequired' | translate }}<br></span>
                  <span class="spanRedTag"
                  *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.maxlength">{{ 'Errors.passwordmaxlength' | translate }}<br></span>
                  <span class="spanRedTag"
                  *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.minlength">{{ 'Errors.passwordminlength' | translate }}<br></span>
                  <span class="spanRedTag"
                  *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.pattern">{{ 'Errors.passwordValid' | translate }}<br></span>
                </p>
            </div>
            <!--Error Display to Modal View-->
            <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
              <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
            </div>

          <!--Spinner on Login Load-->
            <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
            </div>
            
            <!-- <div class="captcha" *ngIf="this.captchaToggle">
              <div id="capcha_element" class="g-recaptcha" data-theme="light"
                  style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
                  data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
                </div>
            </div> -->


            <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
            <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              <br>
          </div>
          <p class="mbfs-ciam-noaccount-header"></p>
          <ul class="nav">
            <li><a [routerLink]="[]" (click)="togglePasswordFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ResetPassword' | translate }}</a></li>
            <li><a [routerLink]="[]" (click)="toggleForgotUserFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ForgotUser' | translate }}</a></li>
          </ul>
      </div>

    <!--Is Reset Flow Modal-->
      <div class="mbfs-modal-content" *ngIf="!isReset">
        <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner">
          <div class="input-group">
            <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
            <input [readonly]="isReset" style="border: 0;" type="text" id="userID" name="userID" class="col-md-6 form-control"
            value="userForm.get('userID').value" formControlName="userID" [class.mbfs-value]="loginForm.get('userID').value" />
          </div>

          <div class="redOverlay">
            <p class="mbfs-reset-password">{{ 'LoginModal.PasswordExpired' | translate }}</p>
            <button (click)="togglePasswordFlag($event)" class="mbfs-button">OK</button>
          </div>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            <br>
        </div>
      </div>
  </div>
  </form>

<!--MFA Login Code-->
<form [formGroup]="loginForm" (ngSubmit)="login()" *ngIf="openLoginModal && userExist && !MFACheck">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
  [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>

    <!--If user Exists and and password does not need to be reset -->
    <div class="mbfs-modal-content">
        <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner">
            <div class="mbfs-text-input" [ngClass]="formValidationClasses">
              <div class="form-group row m-2">
                <div class="input-group">
                  <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
                  <input type="text" id="userID" name="userID" class="col-md-6 form-control"
                    formControlName="userID" required validateonblur
                    value="userForm.get('userID').value" autocomplete="off" [class.mbfs-value]="userForm.get('userID').value" />
              </div>
            </div>
            <p class="mbfs-field-assistance">
              <span class="spanRedTag"
              *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.required">{{ 'Errors.userIdRequired' | translate }}<br></span>
              <span class="spanRedTag"
              *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.minlength">{{ 'Errors.userIdminlength' | translate }}<br></span>
              <span class="spanRedTag"
              *ngIf="this.loginForm.get('userID') && this.loginForm.get('userID').errors && this.loginForm.get('userID').dirty && this.loginForm.get('userID').touched && this.loginForm.get('userID').errors.maxlength">{{ 'Errors.userIdmaxlength' | translate }}<br></span>

            </p>
            </div>

            <div class="mbfs-text-input" [ngClass]="formValidationClasses">
              <div class="form-group row m-2">
                <div class="input-group">
                  <label for="password" class="col-md-3 col-form-label">{{ 'LoginModal.PasswordLabel' | translate }}</label>
                  <input type="password" name="password" id="password" #password1 class="col-md-6 form-control"
                  formControlName="password" required validateonblur
                  value="" onPaste="return false" autocomplete="off" [class.mbfs-value]="loginForm.get('password').value">
                  <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, 1)">
                    <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                  </div>
                </div>
              </div>
              <p class="mbfs-field-assistance">
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.required">{{ 'Errors.passwordRequired' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.maxlength">{{ 'Errors.passwordmaxlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.minlength">{{ 'Errors.passwordminlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.loginForm.get('password') && this.loginForm.get('password').errors && this.loginForm.get('password').dirty && this.loginForm.get('password').touched && this.loginForm.get('password').errors.pattern">{{ 'Errors.passwordValid' | translate }}<br></span>
              </p>
          </div>
          <!--Error Display to Modal View-->
          <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
            <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
          </div>

        <!--Spinner on Login Load-->
          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="mbfs-loading-spinner-overlay"></div>
                <div class="mbfs-loading-spinner"> </div>
          </div>

          <!-- <div class="captcha" *ngIf="this.captchaToggle">
            <div id="capcha_element" class="g-recaptcha" data-theme="light"
                style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
                data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
              </div>
          </div> -->

          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            <br>
        </div>
        <p class="mbfs-ciam-noaccount-header"></p>
        <ul class="nav">
          <li><a [routerLink]="[]" (click)="togglePasswordFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ResetPassword' | translate }}</a></li>
          <li><a [routerLink]="[]" (click)="toggleForgotUserFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ForgotUser' | translate }}</a></li>
        </ul>
    </div>
</div>
</form>

<!--MFA OTP Code-->
<form [formGroup]="loginForm" (ngSubmit)="emailVerificationForLogin($event)" *ngIf="openLoginModal && userExist && MFACheck">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
  [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div>

    <!--If user Exists and and password does not need to be reset -->
    <div class="mbfs-modal-content"> 
      <h3 class="mbfs-modal-header">{{ 'MFA.MFAHeader' | translate }}</h3>
      <div class="mbfs-bank-profile-create-inner"> 
          <p class="mbfs-passwordreset-p">{{ 'MFA.MFAParagraph1' | translate }} <b>{{this.email}}</b> {{ 'MFA.MFAParagraph2' | translate }}</p>
          <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
          <br><p class="mbfs-passwordreset-p">{{ 'MFA.MFAParagraph3' | translate }}</p><br>
        <!--Spinner on Login Load-->
        <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
          <div class="mbfs-loading-spinner-overlay"></div>
          <div class="mbfs-loading-spinner"> </div>
        </div>
        <!--Error Display to Modal View-->
        <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
          <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
        </div>
        <button type="submit"  [disabled]="(!this.loginLoaded || !this.MFATimeout)" class="mbfs-button" (click)="submitPreLoginForm()" >{{ 'LoginModal.ResendLink' | translate }}</button>                
        <button type="submit"  [disabled]="(!this.loginLoaded || !this.MFALockout)" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
        <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
        <br><br>
        <p class="mbfs-passwordreset-p">{{ 'MFA.MFAReregister' | translate }}</p>
      </div>
    </div>
</div>
</form>


</div>


<div *ngIf="displayAdmin">
  <!-- Admin Modal check user-->
  <form [formGroup]="adminForm" (ngSubmit)="submitAdminUserForm($event)" *ngIf="openLoginModal && !userExist">
    <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
      <div class="mbfs-modal-overlay"></div>

      <!--If user Exists and and password does not need to be reset -->
      <div class="mbfs-modal-content" *ngIf="!isReset && !userExist">
          <h3 class="mbfs-modal-header">ACM Login</h3>
          <div class="mbfs-bank-profile-create-inner">
              <div class="mbfs-text-input" [ngClass]="formValidationClasses">
                <div class="form-group row m-2">
                  <div class="input-group">
                    <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
                    <input type="text" id="userID" name="userID" class="col-md-6 form-control"
                      formControlName="userID" required validateonblur
                      value="" autocomplete="off" [class.mbfs-value]="adminForm.get('userID').value" />
                </div>
              </div>
              <p class="mbfs-field-assistance">
                <span class="spanRedTag"
                *ngIf="this.adminForm.get('userID') && this.adminForm.get('userID').errors && this.adminForm.get('userID').dirty && this.adminForm.get('userID').touched && this.adminForm.get('userID').errors.required">{{ 'Errors.userIdRequired' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.adminForm.get('userID') && this.adminForm.get('userID').errors && this.adminForm.get('userID').dirty && this.adminForm.get('userID').touched && this.adminForm.get('userID').errors.minlength">{{ 'Errors.userIdminlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.adminForm.get('userID') && this.adminForm.get('userID').errors && this.adminForm.get('userID').dirty && this.adminForm.get('userID').touched && this.adminForm.get('userID').errors.maxlength">{{ 'Errors.userIdmaxlength' | translate }}<br></span>
              </p>
              </div>

            <!--Error Display to Modal View-->
            <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
              <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
            </div>
            <!-- <div class="captcha" *ngIf="this.captchaToggle">
              <div id="capcha_element" class="g-recaptcha" data-theme="light"
                  style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
                  data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
                </div>
            </div> -->
            <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
            <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
              <br>
          </div>
      </div>

  </div>
  </form>

  <!-- Admin Modal Code if User Exists -->
  <form [formGroup]="adminloginForm" (ngSubmit)="submitAdminLoginForm($event)" *ngIf="openLoginModal && userExist">
    <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
    [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
      <div class="mbfs-modal-overlay"></div>

      <!--If user Exists and and password does not need to be reset -->
      <div class="mbfs-modal-content" *ngIf="isReset">
        <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner">
            <div class="mbfs-text-input" [ngClass]="formValidationClasses">
              <div class="form-group row m-2">
                <div class="input-group">
                  <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
                  <input type="text" id="userID" name="userID" class="col-md-6 form-control"
                    formControlName="userID" required validateonblur
                    value="adminForm.get('userID').value" autocomplete="off" [class.mbfs-value]="adminloginForm.get('userID').value" />
              </div>
            </div>
            <p class="mbfs-field-assistance">
              <span class="spanRedTag"
              *ngIf="this.adminloginForm.get('userID') && this.adminloginForm.get('userID').errors && this.adminloginForm.get('userID').dirty && this.adminloginForm.get('userID').touched && this.adminloginForm.get('userID').errors.required">{{ 'Errors.userIdRequired' | translate }}<br></span>
              <span class="spanRedTag"
              *ngIf="this.adminloginForm.get('userID') && this.adminloginForm.get('userID').errors && this.adminloginForm.get('userID').dirty && this.adminloginForm.get('userID').touched && this.adminloginForm.get('userID').errors.minlength">{{ 'Errors.userIdminlength' | translate }}<br></span>
              <span class="spanRedTag"
              *ngIf="this.adminloginForm.get('userID') && this.adminloginForm.get('userID').errors && this.adminloginForm.get('userID').dirty && this.adminloginForm.get('userID').touched && this.adminloginForm.get('userID').errors.maxlength">{{ 'Errors.userIdmaxlength' | translate }}<br></span>

            </p>
            </div>

            <div class="mbfs-text-input" [ngClass]="formValidationClasses">
              <div class="form-group row m-2">
                <div class="input-group">
                  <label for="password" class="col-md-3 col-form-label">{{ 'LoginModal.PasswordLabel' | translate }}</label>
                  <input type="password" name="password" id="password" #password1 class="col-md-6 form-control"
                  formControlName="password" required validateonblur
                  value="" onPaste="return false" autocomplete="off" [class.mbfs-value]="adminloginForm.get('password').value">
                  <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, 1)">
                    <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                  </div>
                </div>
              </div>
              <p class="mbfs-field-assistance">
                <span class="spanRedTag"
                *ngIf="this.adminloginForm.get('password') && this.adminloginForm.get('password').errors && this.adminloginForm.get('password').dirty && this.adminloginForm.get('password').touched && this.adminloginForm.get('password').errors.required">{{ 'Errors.passwordRequired' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.adminloginForm.get('password') && this.adminloginForm.get('password').errors && this.adminloginForm.get('password').dirty && this.adminloginForm.get('password').touched && this.adminloginForm.get('password').errors.maxlength">{{ 'Errors.passwordmaxlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.adminloginForm.get('password') && this.adminloginForm.get('password').errors && this.adminloginForm.get('password').dirty && this.adminloginForm.get('password').touched && this.adminloginForm.get('password').errors.minlength">{{ 'Errors.passwordminlength' | translate }}<br></span>
                <span class="spanRedTag"
                *ngIf="this.adminloginForm.get('password') && this.adminloginForm.get('password').errors && this.adminloginForm.get('password').dirty && this.adminloginForm.get('password').touched && this.adminloginForm.get('password').errors.pattern">{{ 'Errors.passwordValid' | translate }}<br></span>
              </p>
          </div>
          <!--Error Display to Modal View-->
          <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
            <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
          </div>

        <!--Spinner on Login Load-->
          <div *ngIf="(!this.loginLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="mbfs-loading-spinner-overlay"></div>
                <div class="mbfs-loading-spinner"> </div>
          </div>


          <button type="submit" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            <br>
        </div>
        <p class="mbfs-ciam-noaccount-header"></p>
        <ul class="nav">
          <li><a [routerLink]="[]" (click)="togglePasswordFlag($event)"  class="mbfs-ciam-register-link">{{ 'LoginModal.ResetPassword' | translate }}</a></li>
        </ul>
    </div>

    <!--Is Reset Flow Modal-->
      <div class="mbfs-modal-content" *ngIf="!isReset">
        <h3 class="mbfs-modal-header">{{ 'LoginModal.Header' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner">
          <div class="input-group">
            <label class="col-md-3 col-form-label" for="userID">{{ 'LoginModal.UserLabel' | translate }}</label>
            <input [readonly]="isReset" style="border: 0;" type="text" id="userID" name="userID" class="col-md-6 form-control"
            value="adminloginForm.get('userID').value" formControlName="userID" [class.mbfs-value]="adminloginForm.get('userID').value" />
          </div>

          <div class="redOverlay">
            <p class="mbfs-reset-password">{{ 'LoginModal.PasswordExpired' | translate }}</p>
            <button (click)="togglePasswordFlag($event)" class="mbfs-button">OK</button>
          </div>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            <br>
        </div>
      </div>
      
  </div>
  </form>
</div>




<div *ngIf = "passwordResetFlag">
  <!-- <div class="dtf-passwordresetpage"></div> -->
   <div class="dtf-resetpassword"></div>

</div> 
<div *ngIf = "registrationClick">
  <div class="dtf-registrationPopuppage"></div>
</div> 

<div *ngIf = "forgotUserFlag">
  <div class="dtf-forgotUserpage"></div>
</div> 

<a id="mbfs-header-login-cta" id="auto_trigger1" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)" hidden></a> 
<!-- <div style="background: blue!important;" *ngIf="environment==='stage'">
  <marquee behavior="scroll" direction="left" style="color: white;"><b>{{ 'LoaderPages.StageScroller' | translate }}</b></marquee>
</div> -->
<!-- <div style="background: blue!important;" *ngIf="environment==='local'">
  <marquee behavior="scroll" direction="left" style="color: white;"><b>{{ 'LoaderPages.StageScroller' | translate }}</b></marquee>
</div> -->
<div style="background: blue!important;" *ngIf="environment==='dev'">
  <marquee behavior="scroll" direction="left" style="color: white;"><b>{{ 'LoaderPages.DevScroller'  | translate }}</b></marquee>
</div>
</div>
</div>

<!-- <div *ngIf="guestPay">
  
  <div class="mbfs-header-inner">
    <div [class.fullnav]="!this.registration">

      US Logo
        <a id="mbfs-header-mbfs-logo-cta"  [ngClass]="displayCloseIcon? 'mbfs-home-link mbfs-home-link-hide-logo':'mbfs-home-link'" href="{{ 'Images.Redirect' | translate }}" (click)="onLogoClick($event)">
            <div class="mbfs-logotype">
                <img id="mbfs-header-mbfs-logotype-img" href="/home" style="max-width: 200px; margin-left: 130%;" (click)="onLogoClick($event)" src="static/assets/img/dtf-assets/images/logo.jpg" alt="titlecopy">
            </div>
        </a>
    </div>
</div>
</div> -->

</header></div>

<alertpage></alertpage>